import { render, staticRenderFns } from "./editChoices.vue?vue&type=template&id=9adc0f22&"
import script from "./editChoices.vue?vue&type=script&lang=js&"
export * from "./editChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports